
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { advancedCtf, uploadImg} from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
name: "",
id_card: "",
card_pic: "",
imgSrc: "",
id_pic: "",
card_pic_back: ""
}
},
components:{
XHeader,
Toast
},
created(){
this.SETTOKEN()
},
computed:{
...mapState(['token', 'url'])
},
methods:{
...mapMutations(['SETTOKEN']),
save(){
var that = this









if(this.id_pic==''){
this.sendMsg(this.$t('身份证正面照片'))
}else if(this.card_pic_back==''){
this.sendMsg(this.$t('身份证反面照片'))
}
else{
this.$Loading();
let params = {
token: this.token,
name: this.name,
id_card: this.id_card,
card_pic: this.card_pic,
id_pic: this.id_pic,
card_pic_back: this.card_pic_back
}
advancedCtf(params).then(function(res){
var res = res.data;
that.$Loading.close()

if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.$router.go("-1")

}
})
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(error){
that.$Loading.close()
that.sendMsg(that.$t("提交失败"))
})
}
},
chooseFile(){
this.$refs.upload.click()
},
fileChange(e){
let _this = this
var file=e.target.files[0];
var formdata=new FormData();
formdata.append('图片的字段名',file);
let reader = new FileReader()
reader.readAsDataURL(file) 
reader.onloadend = function () {
_this.$Loading()
uploadImg({file: this.result, token: _this.token}).then(data => {
_this.$Loading.close()
console.log(data.data)
if(data.data.status=='1'){
_this.card_pic =  data.data.data
}else{
_this.sendMsg(data.data.message)
}
}).catch(err => {
file.status = 'failed'
file.message = _this.$t('上传失败')
})
}


},
chooseFile1(){
this.$refs.upload1.click()
},
fileChange1(e){
let _this = this
var file=e.target.files[0];
var formdata=new FormData();
formdata.append('图片的字段名',file);
let reader = new FileReader()
reader.readAsDataURL(file) 
reader.onloadend = function () {
_this.$Loading()
uploadImg({file: this.result, token: _this.token}).then(data => {
_this.$Loading.close()
console.log(data.data)
if(data.data.status=='1'){
_this.id_pic =  data.data.data
}else{
_this.sendMsg(data.data.message)
}
}).catch(err => {
file.status = 'failed'
file.message = _this.$t('上传失败')
})
}


},
chooseFile2(){
this.$refs.upload2.click()
},
fileChange2(e){
let _this = this
var file=e.target.files[0];
var formdata=new FormData();
formdata.append('图片的字段名',file);
let reader = new FileReader()
reader.readAsDataURL(file) 
reader.onloadend = function () {
_this.$Loading()
uploadImg({file: this.result, token: _this.token}).then(data => {
_this.$Loading.close()
console.log(data.data)
if(data.data.status=='1'){
_this.card_pic_back =  data.data.data
}else{
_this.sendMsg(data.data.message)
}
}).catch(err => {
file.status = 'failed'
file.message = _this.$t('上传失败')
})
}


},
sendMsg(content) {
this.msg = content;
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/advancedCtf.vue